import React, { useEffect, useRef, useState } from "react";
import { getIdTypes } from "../../services/idType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faMinus, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { ImagePopup } from "../../components/ImagePopup";
import { CustomDateField } from "../../components/CustomDateField";
import useWebData from "../../hooks/useWebData";
import { tenantId } from "../../config/api";

const defaultDateFormat = "MM/DD/yyyy";

type ExtraInformation = {
    id: number;
    idNumber: string;
    issueDate: string;
    exprationDate: string;
    filePath: string;
    idTypeId: string;
    customerId: number;
    type: string;
    imageSize: number,
};

type Props = {
    itemIndex: number;
    handleDeleteExtraRow: (id: number) => void;
    row: any;
    changeOnExtraValue: (row: any) => void;
    birthDay: string;
    preferredDateFormat?: string;
};

export default function AddIdentification({
    itemIndex,
    handleDeleteExtraRow,
    row,
    changeOnExtraValue,
    birthDay,
    preferredDateFormat = defaultDateFormat,
}: Props) { 
    const { webData }: any = useWebData();
    const [file, setFile] = useState<FileList | null>(null);
    const [popup, setPopup] = useState<boolean>(false);
    const [type, setType] = useState<any[]>([]);
    const [typeValue, setTypeValue] = useState<string>("0");
    const [fileName, setFileName] = useState<string>(row.filePath);
    const [isUpload, setUpload] = useState<boolean>(row.filePath ? true : false);
    const [idNumber, setIdNumber] = useState(row.idNumber);
    const [issuedDateValue, setIssuedDateValue] = useState<string>(row.issueDate ? row.issueDate : "");
    const [expDateValue, setExpDateValue] = useState<string>(row.exprationDate ? row.exprationDate : "");
    const [fileSize, setFileSize] = useState<number>(row.imageSize);

    useEffect(() => {
        getIdTypes(tenantId)
            .then(data => {
                setType(
                    data?.map((item: any) => {
                        return { value: item.id, label: item.name };
                    })
                );
                setTypeValue(row?.idTypeId ? row?.idTypeId : data[0]?.id);
            })
            .catch((error) => {
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let data: ExtraInformation = {
            id: row.id,
            idNumber: idNumber,
            issueDate: issuedDateValue,
            exprationDate: expDateValue,
            filePath: fileName,
            idTypeId: typeValue,
            customerId: row.customerId,
            type: row.type,
            imageSize: fileSize,
        };
        changeOnExtraValue(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber, typeValue, issuedDateValue, expDateValue, isUpload, fileSize, fileName]);

    const inputFileRef = useRef<HTMLInputElement>(null);
    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        /*Selected files data can be collected here.*/
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            setFile(selectedFiles);
            setFileSize(selectedFiles[0].size);
            setPopup(true);
        }
    };

    return (
        <>
            <tr className={`!hidden md:!table-row border-b border-[#E4E7EC]`}>
                <td className="py-2 pr-[0.25rem]">
                    <select
                        className={`w-full px-[5px] py-[8px] border rounded-md outline-none focus:border-[#167AC3] text-sm bg-transparent`}
                        value={typeValue}
                        onChange={(e) => setTypeValue(e.target.value)}
                    >
                        {
                            type?.map((item: any) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))
                        }
                    </select>
                </td>

                <td className="py-2 px-[0.25rem]">
                    <input
                        type="text"
                        className={`w-full px-[5px] py-[8px] border rounded-md outline-none focus:border-[#167AC3] text-sm bg-transparent`}
                        value={idNumber}

                        onChange={(e) => setIdNumber(e.target.value)}
                        required
                    />
                </td>

                <td className="text-right py-2 px-[0.25rem] relative">
                    <CustomDateField
                        value={issuedDateValue}
                        onChange={(value) => {
                            setIssuedDateValue(value);
                        }}
                        dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                        className="w-full px-[5px] py-[5px] border rounded-md outline-none text-sm bg-transparent"
                        showValidMessage={false}
                        required={false}
                    />
                </td>

                <td className="text-right py-2 px-[0.25rem]">
                    <CustomDateField
                        value={expDateValue}
                        onChange={setExpDateValue}
                        dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                        className="w-full px-[5px] py-[5px] border rounded-md outline-none text-sm bg-transparent"
                        showValidMessage={false}
                        required={false}
                    />

                </td>

                <td className="w-[30%] py-2 pl-[0.25rem]">
                    <div className="flex justify-between items-center gap-2">
                        {isUpload ? (
                            <p
                                className={`m-0 cursor-pointer whitespace-nowrap text-ellipsis overflow-hidden w-[100px] text-sm flex items-center gap-1`}
                                onClick={() => setPopup(true)}
                            >
                                <FontAwesomeIcon icon={faPaperclip} className="text-sm text-black" />
                                {fileName}
                            </p>
                        ) : (
                            <>
                                <input
                                    type="file"
                                    ref={inputFileRef}

                                    onChangeCapture={onFileChangeCapture}
                                    className="hidden"
                                />

                                <p
                                    className={`m-0 cursor-pointer text-sm flex items-center gap-1`}
                                    onClick={() => {
                                        if (inputFileRef.current) {
                                            inputFileRef.current.value = "";
                                        }
                                        inputFileRef.current?.click();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCloudArrowUp} className="text-sm text-gray-500 mr-1" />
                                    Upload
                                </p>
                            </>
                        )}

                        <div className="flex flex-row gap-1">
                            <FontAwesomeIcon
                                icon={faMinus}
                                className="text-sm rounded-full px-[1px] bg-gray-500 cursor-pointer text-white hover:bg-red-500"
                                onClick={() => handleDeleteExtraRow(itemIndex)}
                            />
                        </div>
                    </div>
                </td>
            </tr>

            <div className="md:hidden flex flex-col gap-4">
                <div key={itemIndex} className="border rounded-md p-4 shadow-sm bg-white">
                    <div className="mb-2">
                        <span className="block text-xs font-semibold text-gray-600">Type</span>
                        <select
                            className="w-full px-2 py-2 border rounded-md outline-none text-sm"
                            value={typeValue}
                            onChange={(e) => setTypeValue(e.target.value)}
                        >
                            {type?.map((item: any) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-2">
                        <span className="block text-xs font-semibold text-gray-600">ID Number</span>
                        <input
                            type="text"
                            className="w-full px-2 py-2 border rounded-md outline-none text-sm"
                            value={idNumber}
                            onChange={(e) => setIdNumber(e.target.value)}
                        />
                    </div>

                    <div className="mb-2">
                        <span className="block text-xs font-semibold text-gray-600">Issued On</span>
                        <CustomDateField
                            value={issuedDateValue}
                            onChange={(value) => {
                                setIssuedDateValue(value);
                            }}
                            dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                            className="w-full px-[5px] py-[5px] border rounded-md outline-none text-sm bg-transparent"
                            showValidMessage={false}
                            required={false}

                        />
                    </div>

                    <div className="mb-2">
                        <span className="block text-xs font-semibold text-gray-600">Exp. Date</span>
                        <CustomDateField
                            value={expDateValue}
                            onChange={setExpDateValue}
                            dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                            className="w-full px-[5px] py-[5px] border rounded-md outline-none text-sm bg-transparent"
                            showValidMessage={false}
                            required={false}
                        />
                    </div>

                    <div className="flex justify-between items-center gap-2 mt-2">
                        {isUpload ? (
                            <p
                                className="text-sm cursor-pointer text-blue-600"
                                onClick={() => setPopup(true)}
                            >
                                <FontAwesomeIcon icon={faPaperclip} className="mr-1" />
                                {fileName}


                            </p>
                        ) : (
                            <>
                                <input
                                    type="file"
                                    ref={inputFileRef}
                                    onChangeCapture={onFileChangeCapture}
                                    className="hidden"
                                />
                                <p
                                    className="text-sm cursor-pointer text-gray-600"
                                    onClick={() => {
                                        if (inputFileRef.current) {
                                            inputFileRef.current.value = "";
                                        }
                                        inputFileRef.current?.click();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCloudArrowUp} className="mr-1" />
                                    Upload
                                </p>
                            </>
                        )}

                        <FontAwesomeIcon
                            icon={faMinus}
                            className="text-sm text-white bg-gray-500 hover:bg-red-500 rounded-full px-[2px] md:px-2 py-[2px] cursor-pointer"
                            onClick={() => handleDeleteExtraRow(row.id)}
                        />
                    </div>

                </div>
            </div>

            {popup && (
                <ImagePopup
                    handlePopup={() => setPopup(false)}
                    showPopup={popup}
                    setPopup={setPopup}
                    fileName={file}
                    setFile={setFile}
                    fileSize={fileSize}
                    setFileSize={setFileSize}
                    setFileName={(name: string) => {
                        setFileName(name);
                        setUpload(true);
                    }}
                    filePath={fileName}
                    saved={isUpload}
                    item={row}
                />
            )}
        </>

    );
}